<template>
  <div class="section pt-5">
    <consulting-room-datatable
      ref="consulting_room_datatable"
    ></consulting-room-datatable>
  </div>
</template>

<script>
import { get, error_message } from "@/utils";
import ConsultingRoomDatatable from "./consulting_room_datatable/Index.vue";

export default {
  name: "PatientConsultingRooms",
  components: { ConsultingRoomDatatable },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
